<div [className]="className">
  <div class="info-bubble-icon-container">
    <mat-icon> {{ iconName }} </mat-icon>
  </div>
  <div class="info-bubble-text-container">
    <span class="info-bubble-title" [innerHtml]="title"></span>
    <span class="info-bubble-message" [innerHtml]="message"></span>
  </div>
</div>
